import EscrevaContainer from './escreva.page'

export default EscrevaContainer
